import React from 'react'

import PropTypes from 'prop-types'

import { capitalizeFirstLetter } from 'utils/text'

import { WhatHappenNext } from './WhatHappenNext/WhatHappenNext'

import css from './OrderSchedule.css'

const propTypes = {
  deliveryDate: PropTypes.string.isRequired,
  nameFirst: PropTypes.string,
  whenCutoff: PropTypes.string.isRequired,
  interval: PropTypes.string,
  numRecipes: PropTypes.number.isRequired,
  numPortions: PropTypes.number.isRequired,
  showOrderSummary: PropTypes.bool,
}

const defaultProps = {
  nameFirst: '',
  interval: 'weekly',
  showOrderSummary: true,
}

const isValidDate = (date) => (date && date.length) || typeof date === 'object'

const OrderSchedule = ({
  deliveryDate,
  nameFirst,
  whenCutoff,
  interval,
  numRecipes,
  numPortions,
  showOrderSummary,
}) => {
  const isValidDeliveryDate = isValidDate(deliveryDate)
  const isValidWhenCutoff = isValidDate(deliveryDate)

  const isFiveForFourOrder = numRecipes === 5 && numPortions === 4

  return (
    <div data-testing="orderScheduleContainer" className={css.container}>
      <div className={css.header}>
        <h2>{`Congrats on choosing your first recipes, ${capitalizeFirstLetter(
          nameFirst || '',
        )}!`}</h2>
        <p className={css.headerSpacing}>
          We&apos;ll send you an email with tracking information when your first order is on its
          way.
        </p>
        <h2>What happens next?</h2>
      </div>
      <WhatHappenNext
        deliveryDate={deliveryDate}
        whenCutoff={whenCutoff}
        interval={interval}
        isFiveForFourOrder={isFiveForFourOrder}
        isValidWhenCutoff={isValidWhenCutoff}
        isValidDeliveryDate={isValidDeliveryDate}
        showOrderSummary={showOrderSummary}
      />
    </div>
  )
}

OrderSchedule.propTypes = propTypes
OrderSchedule.defaultProps = defaultProps

export { OrderSchedule }
